"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prefixer_1 = __importDefault(require("./prefixer"));

var value_to_string_1 = __importDefault(require("./value-to-string"));

var get_class_name_1 = __importDefault(require("./get-class-name"));
/**
 * Generates the class name and styles.
 */


function getCss(propertyInfo, value) {
  var rules; // Protect against unexpected values

  var valueType = typeof value;

  if (valueType !== 'string' && valueType !== 'number') {
    if (process.env.NODE_ENV !== 'production') {
      var name = propertyInfo.jsName;
      var encodedValue = JSON.stringify(value);
      console.error("\uD83D\uDCE6 ui-box: property \u201C".concat(name, "\u201D was passed invalid value \u201C").concat(encodedValue, "\u201D. Only numbers and strings are supported."));
    }

    return null;
  }

  var valueString = value_to_string_1.default(value, propertyInfo.defaultUnit);
  var className = get_class_name_1.default(propertyInfo, valueString); // Avoid running the prefixer when possible because it's slow

  if (propertyInfo.isPrefixed) {
    rules = prefixer_1.default(propertyInfo.jsName || '', valueString);
  } else {
    rules = [{
      property: propertyInfo.cssName || '',
      value: valueString
    }];
  }

  var styles;

  if (process.env.NODE_ENV === 'production') {
    var rulesString = rules.map(function (rule) {
      return "".concat(rule.property, ":").concat(rule.value);
    }).join(';');
    styles = ".".concat(className, "{").concat(rulesString, "}");
  } else {
    var _rulesString = rules.map(function (rule) {
      return "  ".concat(rule.property, ": ").concat(rule.value, ";");
    }).join('\n');

    styles = "\n.".concat(className, " {\n").concat(_rulesString, "\n}");
  }

  return {
    className: className,
    styles: styles
  };
}

exports.default = getCss;